<div class="container">

  <div class="portalCard">
    <div class="aTitle">
      <mat-icon>email</mat-icon>
      <span>Briefegenerierung</span>
    </div>
    <briefe-app></briefe-app>

  </div>
</div>

